<div class="row" *ngIf="localService.languageContent && localService.languageContent.common" class="{{localService.selectedLanguageCode}}">
  <div class="col-md-12" style="text-align:center;margin-top:10%">
    <div style="font-size: 25px;">{{message == '' ? localService.languageContent.common.no_access_to_page : message}}</div>
  </div>
</div>
